import React from 'react';
import { SparklesIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://pagos.academiaholisticaargentina.com/cart/48444837920985:1';
const CHECKOUT_PRO = 'https://pagos.academiaholisticaargentina.com/cart/48444840083673:1';
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  return <section className="relative bg-black text-white py-12 md:py-16 px-5 sm:px-6 overflow-hidden border-t border-white/5" data-id="element-104">
      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-105">
        <div className="mb-6" data-id="element-106">
          <SparklesIcon className="w-8 h-8 text-[#eab308] mx-auto mb-4 animate-pulse" data-id="element-107" />
        </div>

        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white" data-id="element-108">
          Esta es tu decisión
        </h2>

        <div className="space-y-3 text-lg md:text-xl text-gray-300 font-light leading-relaxed max-w-2xl mx-auto mb-8" data-id="element-109">
          <p data-id="element-110">Podés seguir buscando el curso perfecto.</p>
          <p data-id="element-111">Podés seguir esperando el momento ideal.</p>
          <p data-id="element-112">Podés seguir sintiendo que el Reiki te llama sin responderle.</p>
          <p className="text-white font-medium mt-6" data-id="element-113">O podés empezar hoy.</p>
          <p data-id="element-114">
            Con un sistema completo. Con una garantía real. Con todo lo que
            necesitás para transformar tu relación con el Reiki — y si querés,
            con tu economía también.
          </p>
          <p className="text-[#eab308] font-serif italic text-2xl md:text-3xl mt-8" data-id="element-115">
            "La práctica que transforma no empieza cuando todo está perfecto.
            Empieza cuando decidís empezar."
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-116">
          {/* Pro CTA — FIRST */}
          <div className="bg-gradient-to-b from-[#111111] to-[#0a0a0a] rounded-xl p-6 border-2 border-[#eab308]/50 flex flex-col justify-between relative shadow-[0_0_30px_rgba(234,179,8,0.15)]" data-id="element-117">
            <div className="text-center mb-2" data-id="element-118">
              <span className="inline-block bg-gradient-to-r from-[#eab308] to-[#d4a017] text-[#0f0f1a] text-[10px] font-bold px-3 py-1 rounded-full" data-id="element-119">
                ⭐ RECOMENDADO
              </span>
            </div>
            <div className="mb-6" data-id="element-120">
              <h3 className="text-xl font-serif font-bold text-white mb-2" data-id="element-121">
                💎 Kit Reiki Pro Completo
              </h3>
              <p className="text-gray-400 text-sm mb-4" data-id="element-122">
                Todo lo anterior + Certificado + Documentación + Plantillas +
                Guiones + Masterclass + Garantía 7 días
              </p>
              <p className="text-gray-500 text-sm line-through" data-id="element-123">$84.930</p>
              <p className="text-4xl font-extrabold text-[#eab308]" data-id="element-124">$29.990</p>
            </div>
            <a href={CHECKOUT_PRO} target="_blank" rel="noopener noreferrer" className="w-full block px-4 py-4 rounded-xl text-[#0f0f1a] font-bold text-sm tracking-widest uppercase transition-all shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50 text-center" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-125">
              💎 QUIERO EL KIT PRO
            </a>
          </div>

          {/* Base CTA — SECOND */}
          <div className="bg-[#111111] rounded-xl p-6 border border-white/10 flex flex-col justify-between" data-id="element-126">
            <div className="mb-6" data-id="element-127">
              <h3 className="text-xl font-serif font-bold text-white mb-2" data-id="element-128">
                📦 Sistema Maestría Reiki
              </h3>
              <p className="text-gray-400 text-sm mb-4" data-id="element-129">
                6 Tomos + 6 Bonos + Garantía 7 días + Acceso de por vida
              </p>
              <p className="text-gray-500 text-sm line-through" data-id="element-130">$47.940</p>
              <p className="text-4xl font-extrabold text-white" data-id="element-131">$19.990</p>
            </div>
            <a href={CHECKOUT_BASE} target="_blank" rel="noopener noreferrer" className="w-full block px-4 py-4 rounded-xl text-white font-bold text-sm tracking-widest uppercase transition-all hover:-translate-y-1 bg-white/10 hover:bg-white/15 border border-white/20 hover:border-white/30 text-center" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-132">
              📦 QUIERO LA MAESTRÍA
            </a>
          </div>
        </div>

        <div className="mt-10 text-gray-400 text-xs md:text-sm font-medium" data-id="element-133">
          <p data-id="element-134">
            🔒 Pago seguro — Acceso inmediato — Garantía 7 días sin preguntas
          </p>
          <p className="mt-4 text-gray-500 italic" data-id="element-135">
            © Academia Holística Argentina — Sistema Maestría Reiki
            <br data-id="element-136" />
            Material de uso educativo. No reemplaza diagnóstico ni tratamiento
            médico profesional.
          </p>
        </div>
      </div>
    </section>;
}